import { createApp } from 'vue';
import App from './App.vue';
import router from "./router";
import i18n from './i18n';
import store from "./state/store";


import PrimeVue from 'primevue/config';
import BootstrapVueNext from 'bootstrap-vue-next';
import ToastService from 'primevue/toastservice';

import '@/assets/scss/config/corporate/app.scss';
import '@/assets/scss/mermaid.min.css';
import 'bootstrap/dist/js/bootstrap.bundle'
import 'primevue/resources/themes/aura-light-blue/theme.css'

// FakeBackend authentication
// import { configureFakeBackend } from './helpers/fake-backend';
// configureFakeBackend();

createApp(App)
    .use(store)
    .use(router)
    .use(PrimeVue)
    .use(BootstrapVueNext)
    .use(i18n)
    .use(ToastService)
    .mount('#app');